import RadioGroup from "@/components/RadioGroup/RadioGroup.tsx";
import { ParcelObjectType } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const ParcelObjectCategoryPicker = ({ cartItem }: { cartItem: CartAccommodationItem }) => {
  const { t } = useTranslation();
  const { setCartItemParcelObjectType, setCartItemParcelObjectHasMover } = useEngineStore(
    useShallow((state) => ({
      setCartItemParcelObjectType: state.setCartItemParcelObjectType,
      setCartItemParcelObjectHasMover: state.setCartItemParcelObjectHasMover,
    })),
  );

  useEffect(() => {
    setCartItemParcelObjectType(options[0]?.value, cartItem?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = [
    { value: ParcelObjectType.Camper, label: t("campSpecific.camper") },
    { value: ParcelObjectType.Tent, label: t("campSpecific.tent") },
    { value: ParcelObjectType.Caravan, label: t("campSpecific.caravan") },
  ];

  const handleChange = (type: string) => {
    const parcelType = type as ParcelObjectType;
    setCartItemParcelObjectType(parcelType, cartItem?.id);
    if (parcelType !== ParcelObjectType.Caravan) {
      setCartItemParcelObjectHasMover(undefined, cartItem?.id);
    }
  };

  return <RadioGroup options={options} onChange={handleChange} value={cartItem?.parcelObjectType} />;
};
